import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './brand.module.scss';

const METADATA = Metadata.define({
  description: 'Secondary brand badge indicator.',
  name: 'Brand Secondary Badge',
});

export default class SpdsIndicatorBadgeBrandSecondary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  secondary = true;
  variantClass = 'spds-indicator-badge-brand';
  variantStyles = styles;
}

export const BADGE_BRAND_SECONDARY_METADATA = SpdsIndicatorBadgeBrandSecondary.metadata;
